exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-577548b0]{padding:0;background-color:inherit}", ""]);

// exports
